import { render, staticRenderFns } from "./StepMissingOsh.vue?vue&type=template&id=28db7ce0&scoped=true"
import script from "./StepMissingOsh.vue?vue&type=script&lang=js"
export * from "./StepMissingOsh.vue?vue&type=script&lang=js"
import style0 from "./StepMissingOsh.vue?vue&type=style&index=0&id=28db7ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db7ce0",
  null
  
)

export default component.exports